export enum DialerApiRoutes {
  QueueCallback = '/dialer/queue-callback',
}
